import React from "react";

const ComponentVideo = ({ options }) => {
  //Des
  const { objinfo = {} } = options;
  const { content = {} } = objinfo || {};
  return (
    <div className="slide academy-slide">
      <video src={content.url_cotent} muted playsInline preload="metadata" />
    </div>
  );
};

export default ComponentVideo;
